import { Button, Checkbox, Input, Popconfirm, message } from "antd";
import axios from "axios";
import React, { useEffect, useState } from "react";
import API_HOST from "../config.js";
import SelectAccounts from "./selectAccounts.js";
const { TextArea } = Input;

export const testProfile = {
    id: 1,
    name: "MCC 01",
    selectAccounts :[
      {
        "1": "6492235650",
        "2": "1124064429",
        "4": "MCC MY1103 48",
        "5": "3130240452",
        "6": true,
        "10": 30,
        "11": "1710129751481",
        "12": 1,
        id: "3130240452",
        ocid: "6492235650",
        euid: "1124064429",
        name: "MCC MY1103 48",
        isMCC: true,
        active: true,
      }, {
        "1": "6493491068",
        "2": "1124064429",
        "5": "7142032496",
        "6": false,
        "10": 30,
        "11": "1710202101397",
        "12": 2,
        id: "7142032496",
        ocid: "6493491068",
        euid: "1124064429",
        name: "MCC MY1103 49",
        isMCC: true,
        active: false,
      }
      , {
        "1": "6493491068",
        "2": "1124064429",
        "5": "7142032496",
        "6": false,
        "10": 30,
        "11": "1710202101397",
        "12": 2,
        id: "71420324961",
        ocid: "6493491068",
        euid: "1124064429",
        name: "MCC MY1103 49",
        isMCC: true,
        active: false,
      }
      , {
        "1": "6493491068",
        "2": "1124064429",
        "5": "7142032496",
        "6": false,
        "10": 30,
        "11": "1710202101397",
        "12": 2,
        id: "71420324962",
        ocid: "6493491068",
        euid: "1124064429",
        name: "MCC MY1103 49",
        isMCC: true,
        active: false,
      }
    ]
}
function CancelAccounts(props) {
  const [profileModel, setProfileModel] = useState(testProfile);
  const [accounts, setAccounts] = useState('');
  const [mccId, setMccId] = useState('');
  const [mccList, setMccList] = useState([]);
  const [count, setCount] = useState(0);
  const [hide, setHide] = useState(true);
  const [messageApi, contextHolder] = message.useMessage();

  const cancel = async () => {
    let body = {
        profile: props.profile,
        mccId: mccId,
        mccList: mccList,
        accounts: accounts,
        hide: hide
    };
    axios
      .post(`${API_HOST}/api/account/cancel`, body)
      .then((res) => messageApi.success("Đã đặt lệnh"))
      .catch((e) => {
        console.log("🚀 ~ cancel ~ e:", e);
        messageApi.error(e.response.data);
      });
  };

  const onOpenChange = (open) => {
    if (open) {
      axios
        .get(`${API_HOST}/api/profiles/${props.profile.id}`)
        .then((res) => {
          if (res.data) {
            setProfileModel(res.data[0]);
          }
        })
        .catch((e) => {
          messageApi.error("Không thể lấy thông tin Profile");
        });
    }
  };
  useEffect(() => {
    let count = accounts.split('\n');
    if(count) {
      count = count.filter(s => s.trim().length>0);
      setCount(count.length);
    }
  }, 
  [accounts]);

  return (
    <>
      {contextHolder}
      <Popconfirm
        style={{ width: 500 }}
        onOpenChange={onOpenChange}
        placement="left"
        okText="OK"
        cancelText="Hủy"
        title="Hủy và Ẩn Tài Khoản"
        description={
          <>
              {profileModel?.errorMsg?.length> 0  &&
                <label style={{ color: "red", border: '1px solid red'}}>
                  <strong>{profileModel?.errorMsg}</strong></label>
              }
              <br />
              <label>Nhập MCC ID (Nếu có nhiều TK MCC):</label><br />
              <Input style={{width: 300}}
                  placeholder="MCC ID"
                  onChange={(e) => setMccId(e.target.value ) }
              />
              <br />
              <label>Hoặc: </label>
              <SelectAccounts selectAccounts={profileModel?.selectAccounts} 
                onSelected={(selected) => setMccList(selected)}
              />
              <br />
              <br />
              <Checkbox checked={hide} onChange={e => setHide(e.target.checked)}>
                Ẩn sau khi Hủy
              </Checkbox>
              <br />
              <i style={{color:'red'}}>Auto check TK suspended</i><br />
              <br />
              <label>Nhập thêm ID Tài khoản <i style={{color:'red'}}>(Mỗi ID 1 dòng)</i>: <br />
              Số Lượng: <strong>{count}</strong>
              </label>
              <br />
              <TextArea rows={10} 
                    value={accounts} 
                    onChange={(e) => setAccounts(e.target.value)} 
              />
            <br />
          </>
        }
        onConfirm={() => cancel()}
      >
        <Button danger>Hủy & Ẩn TK</Button>
      </Popconfirm>
    </>
  );
}
export default CancelAccounts;